<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">
          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="机构" required prop="institutionCode">
                <el-select v-model="addForm.institutionCode" @change="insChange" placeholder="请选择机构" style="width: 100%">
                  <el-option
                      v-for="item in arr_ins"
                      :key="item.institutionCode"
                      :label="item.userName"
                      :value="item.institutionCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12" class="item">
              <el-form-item label="评估类型" required prop="checkinAssessClassCode">
                <el-select v-model="addForm.checkinAssessClassCode" placeholder="请选择评估类型" style="width: 100%">
                  <el-option
                      v-for="item in listClass"
                      :key="item.checkinAssessClassCode"
                      :label="item.name"
                      :value="item.checkinAssessClassCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="选择残疾人" required prop="userName">
                <el-input v-model="addForm.userName" placeholder="请选择残疾人" disabled>
                  <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>



      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm('addForm')">下一步</el-button>
      </div>
    </div>


    <GetElderly ref="myGetElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false"  v-on:setElderly="setElderly"></GetElderly>

    <SelectItem ref="mySelectItem" v-show="showModalSelectItem" v-on:closeSelectItem="closeSelectItem"
                v-on:getListOut="getListOut" v-on:closeOut="closeOut"></SelectItem>


  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import GetElderly from "@/views/Elderly/Comm/ElderlyInsSigning3";
import SelectItem from "./SelectItem";


export default {
  name: 'Add',
  props: ['arr_ins'],
  data() {
    return {

      loading: false,

      showModalGetElderly: false,
      showModalSelectItem: false,

      addForm:{
        timeStr:timeStr,
        sign:'',
        institutionCode:'',
        userName:'',
        userCode:'',
        elderlyCode:'',
        checkinAssessClassCode:'',
      },

      listClass:[],

      rules:{
        userName:[
          { required: true, message: '请选择老人', trigger: 'blur' }
        ],
        checkinAssessClassCode:[
          { required: true, message: '请选择评估类型', trigger: 'blur' },
        ],
      },

      type:'',

    }
  },
  components: {GetElderly,SelectItem},
  methods: {
    init(type){
      this.type = type;

      this.$refs.addForm.resetFields();

    },
    closeSelf() {
      this.$emit("closeSelectElderly");
    },

    insChange(val){
      this.addForm.institutionCode = val;

      this.addForm.elderlyCode = '';
      this.addForm.userName = '';

      this.getList();
    },


    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myGetElderly.init(this.type,this.addForm.institutionCode);
    },
    setElderly(row){
      this.addForm.userCode=row.userCode;
      this.addForm.userName = row.name;
      this.addForm.elderlyCode = row.elderlyCode;
    },

    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CheckinAssessGroup/GovList",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
          institutionCode:this.addForm.institutionCode,
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.listClass=response.data.data;
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },



    confirm(addForm){

      this.$refs[addForm].validate((valid) => {
        if(valid){

          this.showSelectItem();

        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },


    showSelectItem(){
      this.showModalSelectItem = !this.showModalSelectItem;
      this.$refs.mySelectItem.init(this.addForm.elderlyCode,this.addForm.userName,
          this.addForm.checkinAssessClassCode,this.addForm.institutionCode);
    },
    closeSelectItem(){
      this.showModalSelectItem = !this.showModalSelectItem;
    },

    getListOut(){
      this.$emit("getList");
    },
    closeOut(){
      this.closeSelf();
    },


  }
}
</script>

